import * as SidebarLink from 'components/sidebar/SidebarLink';
import { IntercomProductTourTargets } from 'constants/intercom';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const ReportingLinks = () => {
    const { accountId } = useCurrentAccount();
    const linkPath = `/accounts/${accountId}/reports`;

    return (
        <SidebarLink.Link
            to={linkPath}
            data-intercom-target={IntercomProductTourTargets.SidebarReportsLink}
        >
            <SidebarLink.LevelOne
                icon="windowChartLine"
                isActive={location.pathname.includes(linkPath)}
            >
                Custom Reports
            </SidebarLink.LevelOne>
        </SidebarLink.Link>
    );
};

export { ReportingLinks };
